import { genres } from './../../core/mocks/genres';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MoviesService } from '../../core/services/movies.service';
import { MovieModel } from 'src/app/core/interfaces/movie.model';

@Component({
  selector: 'app-search-genre',
  templateUrl: './search-genre.component.html',
  styleUrls: ['./search-genre.component.css'],
})
export class SearchGenreComponent implements OnInit {
  genreName: string;
  movies: MovieModel[] = [];
  loading: boolean = false;

  constructor(private activatedRoute: ActivatedRoute, private moviesService: MoviesService, private router: Router) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.loading = true;

      this.moviesService.getMovieGenre(Number(params.genre)).subscribe((resp) => {
        this.loading = false;

        if (resp.length > 0) {
          this.genreName = resp[0].genre.name;

          this.movies = resp;
        }
      });
    });
  }

  goMovie(idMovie) {
    this.router.navigate(['/movie', idMovie]);
  }
}
